import React, { Component } from "react";
import { alert, GET, PUT, loading, Navbar, profile, required, float, format_date } from "../../components/CustomComponent.js";
import Footer from "../../components/Footer.js";
import "bootstrap/dist/css/bootstrap.min.css";

export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: profile?.uid || "",
      full_name: "",
      phone: "",
      role_id: "",
      email: "",
      password: "",
      is_active: false,
      is_2fa: false,
      is_mismatch_limit_approved: false,
      broker_id: "",

      user_type: "",
      is_phone: false,

      created_at: "",
      addresses: null
    };
  }

  componentDidMount() {
    loading(false)
    this.Get();
    this.loadCustomerAddresses();
  }
Get = async (page) => {
    loading(true);
    let result = await GET("v1/admin/users", { uid: this.state.uid });
      console.log(result)
    if (result?.status) {
      this.setState({
        ...result.data,
        password: "",
        role_id: result.data?.role?.uid || "",
        is_phone: result.data?.phone ? true : false,
      })
    }
    loading(false);
  };
  loadCustomerAddresses = async () => {
        const customerUid = profile?.customer?.uid || process.env.REACT_APP_CUSTOMER_ID_DEFAULT || "";
        console.log("loadCustomerAddresses - customerUid:", customerUid);
        if (!customerUid) return;
    
        const result = await GET("v1/public/market/customer-address", {
          uid: customerUid,
        });
    
        if (result?.status) {
          const addresses = Array.isArray(result?.data) ? result.data : [];
          console.log(addresses)
          this.setState({
            addresses:addresses.find((item) => item.is_default),
          });
          return;
        }else{
              localStorage.clear();
              alert("/", "warning", "แจ้งเตือน", "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง");
            }
    
        this.setState({ addressLoading: false });
      };
  Update = async () => {
    const {
      uid,
      full_name,
      phone,
      role_id,
      email,
      password,
      is_active,
      is_2fa,
      is_mismatch_limit_approved,
      user_type,
      broker_id,
    } = this.state;
    if (!full_name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อ");
      return;
    }
    if (
      await alert(
        "",
        "info",
        "ยืนยันการส่งข้อมูล",
        "คุณต้องยืนยันการส่งข้อมูลใช่หรือไม่?",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let body = {
        full_name,
        phone,
        role_id,
        email,
        user_type: user_type.replaceAll(" ", "_"),
        password,
        is_active,
        is_2fa,
        is_mismatch_limit_approved,
        broker_id: broker_id || null,
      };
      console.log(body)
      let result = await PUT("v1/admin/users/" + uid, body);
      if (result?.status === true) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };

  render() {
    const { uid,
      full_name,
      phone,
      role_id,
      email,
      password,
      is_active,
      is_2fa,
      is_mismatch_limit_approved,
      user_type,
      broker_id,is_phone, created_at, addresses } = this.state;

    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="row d-flex justify-content-center mx-0">
         <div className="col-12 col-sm-11 col-md-10 col-lg-2 col-xl-2 pt-5 mt-3 d-none d-lg-block">
          {/* ชื่อผู้ใช้ */}
          <div className="d-flex align-items-center text-start">
            <span className="bg-orange text-dark me-1 wpx-50 hpx-50 text-24 rounded-circle d-flex align-items-center justify-content-center">
              ลค
            </span>
            <div className="px-2 ">
              <div className="text-14 fw-bold">{profile?.full_name || "ลูกค้าทั่วไป"}</div>
              <div className="text-12 text-dark" style={{ marginTop: -2 }}>
                {profile?.phone || "-"}
              </div>
            </div>
          </div>
          {/* เมนู */}
          <div className="py-3">
            <a href="/profile" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
              <div className="d-flex"><span className="icon me-2">{"\uf007"}</span>บัญชีของฉัน</div>
            </a>
            <a href="/address" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
              <div className="d-flex"><span className="icon me-2">{"\uf015"}</span>ที่อยู่ของฉัน</div>
            </a>
            <a href="/change-password" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
              <div className="d-flex"><span className="icon me-2">{"\uf084"}</span>เปลี่ยนรหัสผ่าน</div>
            </a>
            <a href="/transaction" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
              <div className="d-flex"><span className="icon me-2">{"\uf570"}</span>การซื้อของฉัน</div>
            </a>
          </div>
        </div>
        <div className="col-12 col-sm-11 col-md-10 col-lg-9 col-xl-7 col-xxl-6 my-4 px-3 min-vh-100">
          <h4 className="fw-bold mb-3">บัญชีของฉัน</h4>
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ชื่อ{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อ..."
                onChange={(e) => {
                  this.setState({ full_name: e.target.value });
                }}
                value={full_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">อีเมล</div>
              {email.includes("@") && email.includes(".") ? (
              <div className="mt-2">{email.split("@")[0].slice(0,1)}*****{email.split("@")[0].slice(-1)}@{email.split("@")[1]}</div>
              ) : (<div className="mt-2">{email || "-"}</div>)}
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">เบอร์โทรศัพท์{required}</div>
              {is_phone ? (
                <div className="mt-2">********{phone.slice(-2)} <span className="ms-2 text-primary pointer" onClick={() => {this.setState({is_phone: false})}}>เปลี่ยน</span></div>
              ) : (
              <input
                type="text"
                className="form-control"
                placeholder="เบอร์โทรศัพท์..."
                maxLength={10}
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ phone: e.target.value });
                }}
                value={phone}
              />
              )}
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">วันที่สร้างบัญชี</div>
              <div className="mt-2">{created_at ? format_date(created_at,"dd mmmm yyyy hh:mm:ss น.") : "-"}</div>
              </div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ที่อยู่หลัก</div>
              <div className="mt-2">{addresses?.address || ""} {addresses?.sub_district ? ` ต.${addresses?.sub_district}` : ""} {addresses?.district ? ` อ.${addresses?.district}` : ""} {addresses?.province ? ` จ.${addresses?.province}` : ""} {addresses?.zipcode || ""} {addresses?.contact_phone && (<span className="text-secondary">({addresses?.contact_phone})</span>)}</div>
              </div>
            <div className="d-flex justify-content-end">
              <button className="btn btn-dark px-4" onClick={() => {this.Update()}}>บันทึก</button>
            </div>
          </div>
          <button className="btn btn-link text-decoration-none text-danger px-0"
           onClick={async () => {
            if(await alert("","info","ยืนยันการลบบัญชี","คุณต้องการลบบัญชีใช่หรือไม่?","ยืนยัน","ยกเลิก")){
              this.setState({is_active: false},() => {
                this.Update()
              })
            }
          }}
          ><span className="icon me-2">{"\uf1f8"}</span>ขอลบบัญชีผู้ใช้งาน</button>
              
        </div>
      </div>
        
      <Footer />
      </div>
    );
  }
}